import { render } from "./individual-shares-table.vue?vue&type=template&id=1dedef8b&scoped=true"
import script from "./individual-shares-table.vue?vue&type=script&lang=ts"
export * from "./individual-shares-table.vue?vue&type=script&lang=ts"

import "./individual-shares-table.vue?vue&type=style&index=0&id=1dedef8b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1dedef8b"

export default script